export default {
  init() {
    const that = this;
    this.handleRegions();
    this.handleRegionsBreadcrumb();

    $(window).on('load', function() {
      that.scrollToTabContent();
    });
  },
  handleRegions() {
    const globe = $('.globe-image');
    const hash = window.location.hash;

    $('.nav-link').on('click', function() {
      const map = $(this).data('map');
      globe.attr('src', map);
    });

    hash && globe.attr('src', $('.nav-link.active').data('map'));
  },
  scrollToTabContent() {
    const hash = window.location.hash;
    const pos = $('body').find('.nav.nav-tabs').offset().top;
    const offset = 80;
    hash && $('body, html').animate({scrollTop: pos - offset}, 700);
  },
  handleRegionsBreadcrumb() {
    let start_time = new Date().getTime();
    $('.region-container').find('a').on('click', function(e) {
      e.preventDefault();

      const that = $(this);
      const region = {
        type: 'region',
        region: that.data('region'),
        regionSlug: that.data('region-slug'),
        productGroup: that.data('product-group'),
      };

      $.ajax({
        type: 'POST',
        url: window.precisely.ajax_url,
        data: {
          action: 'breadcrumbRegion',
          regionData: region,
        },
        success: function () {
          console.log(
            window.precisely.ajax_url,
            ' Request took ',
            new Date().getTime() - start_time,
            'ms'
          );
          window.location = that.attr('href');
        },
      });
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/templateDataGuideRegion.js